// extracted by mini-css-extract-plugin
export var deleteIcon = "_t8-5";
export var deleteOption = "_t8-3";
export var divider = "_t8-2";
export var downloadIcon = "_t8-4";
export var drawer = "_t8-0";
export var drawerFooter = "_t8-6";
export var drawerOpen = "_t8-1";
export var highlighted = "_t8-7";
export var lighterHighlight = "_t8-8";